import React from "react"
import styled from "styled-components"
import { Container } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"

const StyledHeroContainer = styled(Container)`
  .efficient-images {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 25px;
  }

  .efficient-images-top{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 25px;
  }

  .image-align {
    width: 92px;
    height: 106px;
    transition: transform 0.3s;
  }

  .image-align-top {
    width: 167px;
    height: 44px;
   
  }

  .image-align-hs {
    width: 110px;
    height: 125px;
    transition: transform 0.3s;
  }

  .image-align-hs:hover {
  transform: scale(1.05);
  }

  .image-align:hover {
    transform: scale(1.05);
  }

  .features-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
  }

  .feature-icon {
    color: orange;
    margin-right: 8px;
  }

  @media only screen and (max-width: 600px) {
    .efficient-images {
      gap: 9px !important;
    }
    .features-list {
      gap: 10px;
      font-size: 0.8rem;
    }
  }
`

const EfficientServices = () => {
  return (
    <StyledHeroContainer>
      <div className="text-center">
        <h2 className="fw-bold py-3">
        Consistently Leading With Proven Excellence
        </h2>
        <div className="efficient-images-top py-3 mb-3">
          <a
            href="https://www.g2.com/products/clearout-io/reviews"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align-top"
              src="../../images/g2_rating_workflow.png"
              alt="g2 rating"
            />
          </a>
          <a
            href="https://www.capterra.in/software/183877/clearout"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align-top"
              src="../../images/capterra_rating_workflow.png"
              alt="capterra rating workflow"
            />
          </a>
        </div>
        <div className="efficient-images">
        <a
            href="https://www.g2.com/products/clearout-io/reviews?utm_source=rewards-badge"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align"
              src="../../images/emailverification_momentumleader_Leader_2025spring.png"
              alt="momentum leader spring"
            />
          </a>
          <a
            href="https://www.g2.com/products/clearout-io/reviews?utm_source=rewards-badge"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align"
              src="../../images/emailverification_leader_europe_leader_spring2025.png"
              alt="leader europe spring"
            />
          </a>
          <a
            href="https://www.g2.com/products/clearout-io/reviews?utm_source=rewards-badge"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align-hs"
              src="../../images/emailverification_leader_leader_spring2025.png"
              alt="leader spring 2025"
            />
          </a>
          <a
            href="https://www.g2.com/products/clearout-io/reviews?utm_source=rewards-badge"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align"
              src="../../images/emailverification_leader_emea_leader_spring2025.png"
              alt="email verification leader EMEA spring"
            />
          </a>
         
        
          <a
            href="https://www.g2.com/products/clearout-io/reviews?utm_source=rewards-badge"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              loading="lazy"
              className="image-align"
              src="../../images/leadIntelligence_highperformer_highperformer_spring2025.png"
              alt="leader spring"
            />
          </a>
         
        </div>
      </div>
    </StyledHeroContainer>
  )
}

export default EfficientServices
